import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

export default class NameValidator {
  static isValid(
    name: string,
    viewingMode: ViewingMode,
    parentNode: OrganisationTreeNode | undefined,
    siblings: OrganisationTreeNode[],
  ): boolean {
    const isInvalidInCreationMode =
      viewingMode === 'creation' && parentNode?.childOrganisationUnits?.some((child) => child.name === name.trim());
    const isInvalidInEdittingMode = viewingMode === 'editing' && siblings.some((sibling) => sibling.name === name.trim());

    if (!isInvalidInCreationMode && !isInvalidInEdittingMode) {
      return true;
    }

    return false;
  }
}
